<div class="latest-posts-table" [class.print-mode]="printMode">
	<div class="row">
		<div class="col-sm-12">
			<div class="table-header">
				<div class="header-col index">
					<span class="cell">#</span>
				</div>

				<div class="header-col">
				</div>

				<div class="header-col">
					<span class="cell">{{'INFLUENCER.overview.latest_posts.influencer_post' | translate}}</span>
				</div>

				<div class="header-col">
					<span class="cell">{{'INFLUENCER.overview.latest_posts.reach' | translate}}</span>
				</div>

				<div class="header-col">
					<span class="cell">{{'INFLUENCER.overview.latest_posts.interaction' | translate}}</span>
				</div>

				<div class="header-col">
					<span class="cell">{{'INFLUENCER.overview.latest_posts.impact' | translate}}</span>
				</div>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col-sm-12" *ngFor="let post of posts; let i = index; let isEven = even">
			<a class="latest-post-row" [class.print-mode]="printMode" [class.even]="isEven">
				<div class="latest-post-col index">
					<span>{{i + 1}}</span>
				</div>

				<div class="latest-post-col image">
					<img src="assets/images/No_Image.png" class="post-img">
				</div>

				<div class="latest-post-col influencer-post">
					<div class="influencer-post-container">
						<div class="text-part">
							<div class="post-title">
								<div>-</div>
							</div>
							<span class="post-date">-</span>
						</div>
						<div class="image-part">
							<img src="assets/images/question-mark.png" width="20" height="20">
						</div>
					</div>
				</div>

				<div class="latest-post-col statistics">
					<span placement="bottom" ngbTooltip="{{'info_box.influencer.insight_impact' | translate}}">
						-
					</span>
				</div>

				<div class="latest-post-col statistics">
					<span placement="bottom" ngbTooltip="{{'info_box.influencer.insight_interaction' | translate}}">
						-
					</span>
				</div>

				<div class="latest-post-col statistics">
					<span placement="bottom" ngbTooltip="{{'info_box.influencer.insight_impact' | translate}}">
						- %
					</span>
				</div>
			</a>
		</div>

		<div class="col-12">
			<div class="d-flex flex-auto flex-row footer-line" [class.print-mode]="printMode">
			  <div class="paginate-placeholder">
				<div class="pagginate-button">
				  <svg width="8px" height="15px" viewBox="0 0 19 41">
					<defs></defs>
					<g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					  <g id="Arrow/Left-Copy" transform="translate(-12.000000, -4.000000)" fill="#EEF2F5">
						<path
						  d="M28.949609,44.5859918 L12,24.4995264 L28.949609,4.41407071 C29.3745432,3.90817291 30.1162287,3.86071343 30.6006146,4.29996602 C31.0869498,4.74022838 31.1356807,5.50563864 30.7107466,6.00951689 L15.1061126,24.4995264 L30.7107466,42.9905456 C31.1356807,43.4944239 31.0869498,44.2598341 30.6006146,44.6990867 C30.3784013,44.9000322 30.1045332,45 29.8306651,45 C29.5051422,45 29.1815685,44.8596411 28.949609,44.5859918 Z"
						  id="Fill-1"></path>
					  </g>
					</g>
				  </svg>
				</div>
				<div class="page-info">
				  <div class="current-page">1</div>
				  <div> of 99</div>
				</div>
				<div class="pagginate-button">
				  <svg width="8px" height="15px" viewBox="0 0 19 41">
					<defs></defs>
					<g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					  <g id="Arrow/Right-Copy" transform="translate(-15.000000, -4.000000)" fill="#EEF2F5">
						<path
						  d="M31.949609,44.5859918 L15,24.4995264 L31.949609,4.41407071 C32.3745432,3.90817291 33.1162287,3.86071343 33.6006146,4.29996602 C34.0869498,4.74022838 34.1356807,5.50563864 33.7107466,6.00951689 L18.1061126,24.4995264 L33.7107466,42.9905456 C34.1356807,43.4944239 34.0869498,44.2598341 33.6006146,44.6990867 C33.3784013,44.9000322 33.1045332,45 32.8306651,45 C32.5051422,45 32.1815685,44.8596411 31.949609,44.5859918 Z"
						  id="Fill-1" transform="translate(24.500000, 24.500000) scale(-1, 1) translate(-24.500000, -24.500000) "></path>
					  </g>
					</g>
				  </svg>
				</div>
			  </div>
			</div>
		  </div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-posts/best-performing-posts-placeholder/best-performing-posts-placeholder.component.html